<template>
    <div>
        <!-- DESKTOP -->
        <!-- Titre -->
        <p class="Titre  is-hidden-touch is-size-3" >  NOS REFERENTS   </p><hr>
        <!-- Profils des référents -->
        <div class="image is-hidden-touch">  
            <div class="columns is-centered " >
            <!--Colonne 1 -->
            <div class="column is-one-quarter" >
                <div class="Profil"> 
                    <!-- Profils : image et nom -->   
                    <p ><a href="https://fr.linkedin.com/in/c%C3%B4me-vin%C3%A7otte-72743238"  target="_blank"><img src="../../public/assets/img/Come.png" style="margin-bottom:12%;"> </a><span>Côme VINÇOTTE</span> </p>
                    
                    <p class="is-size-5" style="font-family: 'Montserrat', sans-serif;"><a  style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/c%C3%B4me-vin%C3%A7otte-72743238" >Consultant en SI</a></p><!-- Profils : information survol  -->
                </div>
            </div>
            <div class="column is-one-quarter" >
                <div class="Profil">
                    <!-- Profils : image et nom -->    
                    <p  ><a href="https://fr.linkedin.com/in/laurent-herault-b53ab11b"  target="_blank"><img src="../../public/assets/img/Laurent.png" style="margin-bottom:12%;" > </a><span >Laurent HERAULT</span> </p>
                    <!-- Profils : information survol  -->
                   <p class="is-size-5" style="font-family: 'Montserrat', sans-serif;"><a  style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/laurent-herault-b53ab11b" >Consultant en SAP</a></p>
                </div>
             </div>
            <div class="column is-one-quarter " >
                <div class="Profil">
                    <!-- Profils : image et nom -->   
                    <p  ><a href="https://fr.linkedin.com/in/laurine-thomelin-11018610b"  target="_blank"><img src="../../public/assets/img/Laurine.png" style="margin-bottom:10%;"> </a><span >Laurine THOMELIN </span></p>   
                    <!-- Profils : information survol  -->
                   <p   class="is-size-5" style="font-family: 'Montserrat', sans-serif;"><a style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/laurine-thomelin-11018610b" > Responsable Développement</a></p>
                </div>
            </div>
            </div>
        </div>
        <!-- description  -->   
        <p class="description is-hidden-touch " style="border-left:3px solid #583D6A; padding-left:2%;margin-top:9%;margin-bottom:9%;">
            <!-- description : Pro -->  
            Chez <span style="color:#583D6A;font-weight:bold;">Fobware <em>SI</em></span>  chaque membre possède un domaine d'expertise qui participe au bon déroulement de vos projets. Nous sommes une équipe pleine de ressources, aux compétences diverses. Nous déployons des solutions, sur-mesure, afin de satisfaire vos besoins. Notre expertise est issue de nos clients et de la confiance qu'ils nous accordent.	 
           <!-- description : Etudiant -->  
            <br><br><a ><span  v-on:click="scrollFix('#5')"><router-link to="/contact"> <p class="is-size-3" style="text-decoration:none;font-weight:bold;color:#583D6A; font-family: 'Montserrat', sans-serif;">Nous rejoindre ? </p> </router-link></span></a><br>
            La complémentarité des membres de l'équipe permet d’optimiser le travail et de favoriser une bonne ambiance. Nous sommes toujours ouvert à de nouveaux talents, afin d'enrichir notre équipe, et d'apporter leur bonne humeur ! pourquoi pas<span style="color:#583D6A;font-weight:bold;"> vous</span> ? 
        </p>  

     <!-- MOBILE -TABLET -->
      <!-- Titre -->
        <p class="TitreMobile is-hidden-desktop is-size-5-mobile"  > NOS REFERENTS  </p>
       <!-- Profils des référents -->
        <div class="image is-hidden-desktop">  
         <div class="columns is-centered " style=" padding-top:4%;">
            <!--Colonne 1 -->
            <div class="column is-one-quarter" >    
            <div class="ProfilMobile">    
                <!-- Profils : image et nom --> 
                <p ><a href="https://fr.linkedin.com/in/c%C3%B4me-vin%C3%A7otte-72743238"><img src="../../public/assets/img/Come.png" style="margin-bottom:5%;width:50%;margin-left:25%;"> </a><span>Côme VINÇOTTE</span> </p>
                <!-- Profils : information survol  -->
                <p class="is-size-7" style="margin-bottom:12%;font-family: 'Montserrat', sans-serif;"><a  style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/c%C3%B4me-vin%C3%A7otte-72743238" >Consultant en Système d'Information</a></p>
            </div>
            </div>
            <div class="column is-one-quarter" >  
            <div class="ProfilMobile"> 
                <!-- Profils : image et nom --> 
                <p><a  href="https://fr.linkedin.com/in/laurent-herault-b53ab11b"><img src="../../public/assets/img/Laurent.png" style="margin-bottom:5%;width:50%;margin-left:25%;" > </a><span> Laurent HERAULT</span> </p>
                <!-- Profils : information survol  -->
                <p class="is-size-7" style="margin-bottom:12%;font-family: 'Montserrat', sans-serif;"><a  style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/laurent-herault-b53ab11b" >Consultant en SAP</a></p>
            </div>
            </div>
            <div class="column is-one-quarter" >  
            <div class="ProfilMobile">
                <!-- Profils : image et nom --> 
                <p  ><a href="https://fr.linkedin.com/in/laurine-thomelin-11018610b"><img src="../../public/assets/img/Laurine.png" style="margin-bottom:5%;width:50%;margin-left:25%;"> </a><span>Laurine THOMELIN  </span></p>   
                <!-- Profils : information survol  -->
                <p class="is-size-7" style="margin-bottom:12%;font-family: 'Montserrat', sans-serif;"><a  style="text-decoration:underline; color:black;" target="_blank" href="https://fr.linkedin.com/in/laurine-thomelin-11018610b" >  Responsable Développement</a></p>

            </div>
            </div>
         </div>
        </div>

        <hr class="is-hidden-desktop">
        <!-- description  -->  
        <p class="description  is-hidden-desktop is-size-6" style="margin-bottom:20%;">
            <!-- description : Pro --> 
             Chez <span style="color:#583D6A;font-weight:bold;">Fobware <em>SI</em></span> chaque membre possède un domaine d'expertise qui participe au bon déroulement de vos projets. Nous sommes une équipe pleine de ressources, aux compétences diverses. Nous déployons des solutions, sur-mesure, afin de satisfaire vos besoins. Notre expertise est issue de nos clients et de la confiance qu'ils nous accordent.	
            <!-- description : Etudiant --> 
            <br><br> <span class="is-size-6" style="font-weight:bold;color:#583D6A; font-family: 'Montserrat', sans-serif;"> Nous rejoindre ? </span><br><br>
            La complémentarité des membres de l'équipe permet d’optimiser le travail et de favoriser une bonne ambiance. Nous sommes toujours ouvert à de nouveaux talents, afin d'enrichir notre équipe, et d'apporter leur bonne humeur ! pourquoi pas<span style="color:#583D6A;font-weight:bold;"> vous</span> ? 
        </p>  

     
    </div>
</template>

<script>



export default {
  name: "TeamPage",
   components: {
       
  },
   methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang;
    }
  }
};
</script>
<style scoped> 
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Shippori+Mincho&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
.Profil{
   display: inline-block;
   text-align: center;
   margin-right:6%;
   margin-left:6%;
   position: relative;
  
}
.Info{
    z-index: 1;
    position: absolute; 
    text-align: center;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: 35%;
    color: black;
    width: 100%;
    visibility: hidden;
 
    
}
.Profil span{
  font-size:2.5vh;
  
}



.TitreMobile{
 
 font-family: 'Montserrat', sans-serif;
 font-weight: bold;
 font-size:3.8vh; 
 margin-top:15%;
 margin-bottom:13%;

}
.Titre{
 font-family: 'Montserrat', sans-serif;
 font-weight: bold;
 margin-bottom:2%;
 font-size:3.3vh;
}
hr{
  margin-bottom:7%;
  width:40%;
  margin-left:30%;
  border-top: 4px solid #583D6A;
}

.description{
    font-size:2.5vh;
    margin-top:5%;
    text-align: justify;
    margin-left:15%;
    margin-right:15%;
    font-family: 'Lato', sans-serif;
}



</style>